export default __webpack_public_path__ + "static/media/56_desktop.804189bc.jpg";